var _defs, _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconWebStoreLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .webshopline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.08px;\n      }\n\n      .webshopfill {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "webshopfill",
    d: "M21.23-.52h3.12c1.15,0,2.09.94,2.09,2.09v8.32c0,1.15-.94,2.09-2.09,2.09h-3.12V-.52h0Z",
    transform: "translate(29.56 -18.11) rotate(90)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "webshopline",
    d: "M40.22,44.46c-1.14,1.46-2.93,2.4-4.93,2.4H12.38c-3.45,0-6.25-2.8-6.25-6.25V9.37c0-3.45,2.8-6.25,6.25-6.25h22.91c3.45,0,6.25,2.8,6.25,6.25v4.25"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "webshopfill",
    cx: 26,
    cy: 39.09,
    r: 2.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "webshopfill",
    cx: 38.01,
    cy: 39.09,
    r: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "webshopline",
    d: "M14.32,13.8h4.19l3.35,17.82c.27,1.45,1.48,2.49,2.87,2.46h13.95c1.39.03,2.6-1.01,2.87-2.46l2.3-12.81h-24.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconWebStoreLine);
export default __webpack_public_path__ + "static/media/cloud_icon_web_store_line.6e0f99cd3b9e11d20d5a4bbdc0cec26c.svg";
export { ForwardRef as ReactComponent };